// Centralized runtime configuration

export const config = {
    // CRA exposes only REACT_APP_* variables at runtime
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
    // Prefer CRA-compatible BESU var; fall back to legacy name, but DO NOT default to the general base to avoid hitting wrong host
    besuApiBaseUrl: process.env.REACT_APP_BESU_API_URL,
    apiTimeoutMs: Number(process.env.REACT_APP_API_TIMEOUT_MS || 15000),
    // Base URL for external events/explorer app (used by "View Txn" links)
    eventsAppBaseUrl: (process.env.REACT_APP_EVENTS_BASE_URL || (typeof window !== 'undefined' && window.location ? window.location.origin : '') || '').replace(/\/$/, ''),
};
